import http from '@/utils/http'
import httpApi from '@/apis/httpApi'
// 获取操作日志列表
export const getOperationLogTableList = ({
    pageNum,
    pageSize,
    operationRemark,
    beginDate,
    endDate,
    operationSource,
    operation
}) => {
    return http.usualPost({
        url: httpApi.operationLog.getTableList,
        data: {
            pageNum,
            pageSize,
            operationRemark,
            beginDate,
            endDate,
            operationSource,
            operation
        }
    })
}
//操作平台列表
// export const _operationPlatformList = () => {
//     return http.usualPost({
//         url: httpApi.operationLog.getOperaPlarformList
//     })
// }
//事件类型列表
export const _eventTypeList = () => {
    return http.usualPost({
        url: httpApi.operationLog.getEventTypeList
    })
}